/**
 * Global state for gated video
 */
export function createGatedVideoState() {
    return {
        unlockedVideoIds: {},
        checkedVideoIds: new Set(),
    };
}
